import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllDiarioObrasAtividadesUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_atividades_use_case";
import { DiarioObrasAtividadesFilter } from "../../models/diario_obras_atividades_filter";
import { DiarioObrasAtividadesLista } from "../../models/diario_obras_atividades_lista";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";


// GetAllDiarioObrasAtividadesServicoUseCase


export class GetAllDiarioObrasAtividadesServicoUseCase
  extends BasePaginatedUseCase<DiarioObrasAtividadesLista>
  implements IGetAllDiarioObrasAtividadesUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {
    super();
  }

  async getAllListagemDiariosObrasAtividades(
    filter: DiarioObrasAtividadesFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdDiarioObras === undefined) throw new Error('Id de diario de obra inválido!');

    const response = await this.repository
      .getAllListagemDiariosObrasAtividades(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
